'use client';
import React, { useState } from 'react';
import { TESTIMONIALS } from '@/lib/mockData';
import { Star, ChevronLeft, ChevronRight, Quote } from 'lucide-react';

export default function Testimonials() {
  const [current, setCurrent] = useState(0);

  const prev = () => setCurrent((c) => (c - 1 + TESTIMONIALS?.length) % TESTIMONIALS?.length);
  const next = () => setCurrent((c) => (c + 1) % TESTIMONIALS?.length);

  const t = TESTIMONIALS?.[current];

  return (
    <section className="py-16 lg:py-24 bg-white" id="about">
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 text-[#E8440A] text-sm font-semibold mb-3">
            <Star size={16} className="fill-[#E8440A]" />
            <span>Traveler Stories</span>
          </div>
          <h2 className="section-header text-3xl lg:text-4xl">What Our Adventurers Say</h2>
          <p className="text-gray-500 mt-2">4,200+ travelers. Real experiences. Honest words.</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="card-base p-8 lg:p-12 text-center relative">
            <Quote size={40} className="text-[#E8440A]/20 mx-auto mb-6" />
            <p className="text-gray-700 text-lg lg:text-xl leading-relaxed font-medium mb-8">
              "{t?.text}"
            </p>
            <div className="flex items-center justify-center gap-3 mb-4">
              <div className="w-12 h-12 rounded-full bg-[#1A3C5E] flex items-center justify-center text-white font-bold text-sm">
                {t?.avatar}
              </div>
              <div className="text-left">
                <p className="font-bold text-[#1A3C5E]">{t?.name}</p>
                <p className="text-gray-500 text-sm">{t?.location} — {t?.trip}</p>
              </div>
            </div>
            <div className="flex items-center justify-center gap-1">
              {Array.from({ length: 5 })?.map((_, i) => (
                <Star
                  key={`star-${i}`}
                  size={16}
                  className={i < t?.rating ? 'text-amber-400 fill-amber-400' : 'text-gray-200 fill-gray-200'}
                />
              ))}
            </div>

            {/* Navigation */}
            <div className="flex items-center justify-center gap-3 mt-8">
              <button
                onClick={prev}
                className="p-2.5 rounded-xl border border-gray-200 text-gray-500 hover:border-[#E8440A] hover:text-[#E8440A] transition-all"
              >
                <ChevronLeft size={18} />
              </button>
              <div className="flex gap-2">
                {TESTIMONIALS?.map((_, i) => (
                  <button
                    key={`dot-${i}`}
                    onClick={() => setCurrent(i)}
                    className={`rounded-full transition-all ${i === current ? 'w-6 h-2.5 bg-[#E8440A]' : 'w-2.5 h-2.5 bg-gray-200 hover:bg-gray-300'}`}
                  />
                ))}
              </div>
              <button
                onClick={next}
                className="p-2.5 rounded-xl border border-gray-200 text-gray-500 hover:border-[#E8440A] hover:text-[#E8440A] transition-all"
              >
                <ChevronRight size={18} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}